module.exports = __webpack_public_path__ + "static/media/adm2.88802680.jpg";